module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "u-form u-form--light",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createSquad($event)
      }
    }
  }, [(!_vm.submitted) ? _c('div', [_c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-first-name"
    }
  }, [_vm._v("\n          Squad Name\n          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.name),
      expression: "squad.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        max: 200
      }),
      expression: "{ max: 200 }"
    }],
    attrs: {
      "id": "squad-name",
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.squad.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          If no squad name is provided, a default squad name will be created for you.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-first-name"
    }
  }, [_vm._v("\n          First Name"), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstName')),
      expression: "errors.has('firstName')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('firstName')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.firstName),
      expression: "squad.firstName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    attrs: {
      "id": "squad-first-name",
      "name": "firstName",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.squad.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          Provide the first name of the squad leader.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-last-name"
    }
  }, [_vm._v("\n          Last Name"), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastName')),
      expression: "errors.has('lastName')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('lastName')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.lastName),
      expression: "squad.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{ required: true }"
    }],
    attrs: {
      "id": "squad-last-name",
      "name": "lastName",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.squad.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          Provide the last name of the squad leader.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-zip"
    }
  }, [_vm._v("\n          ZIP*\n          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zip')),
      expression: "errors.has('zip')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('zip')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.zip),
      expression: "squad.zip"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        numeric: true,
        required: true
      }),
      expression: "{ numeric: true, required: true }"
    }],
    attrs: {
      "id": "squad-zip",
      "name": "zip",
      "type": "text",
      "autocomplete": "off",
      "required": ""
    },
    domProps: {
      "value": (_vm.squad.zip)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.zip = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          Provide the squad's zip code. This will be used to determine your squad's judicial district.\n        ")])]), _vm._v(" "), (_vm.noDistricts) ? _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('p', {
    attrs: {
      "role": "alert",
      "data-error": ""
    }
  }, [_vm._v("Sorry, there are no districts available for that ZIP code. Please check that your zip code is correctly entered, or try a different zip code.")])]) : _vm._e(), _vm._v(" "), (!!_vm.districts.length) ? _c('fieldset', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('legend', [_vm._v("\n          Select Your District:\n        ")]), _vm._v(" "), _c('ul', _vm._l((_vm.districts), function(district, index) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.squad.districtId),
        expression: "squad.districtId"
      }],
      attrs: {
        "name": "district-id",
        "id": 'district-id-' + district.node.id,
        "type": "radio"
      },
      domProps: {
        "value": district.node.id,
        "checked": _vm._q(_vm.squad.districtId, district.node.id)
      },
      on: {
        "__c": function($event) {
          _vm.squad.districtId = district.node.id
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "name": "district-id",
        "value": district.node.id,
        "for": 'district-id-' + district.node.id
      },
      model: {
        value: (_vm.squad.districtId),
        callback: function($$v) {
          _vm.squad.districtId = $$v
        },
        expression: "squad.districtId"
      }
    }, [_vm._v("\n              " + _vm._s(district.node.state_abbreviation) + " - " + _vm._s(district.node.name) + " (" + _vm._s(district.node.county_names) + ")\n            ")])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-email"
    }
  }, [_vm._v("\n          Email"), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.email),
      expression: "squad.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        email: true
      }),
      expression: "{ required: true, email: true }"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "squad-email",
      "data-vv-delay": "500"
    },
    domProps: {
      "value": (_vm.squad.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          Provide an email address where future squad members can reach you. This information will not be displayed publicly.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.phone),
      expression: "squad.phone"
    }],
    attrs: {
      "type": "text",
      "id": "squad-phone"
    },
    domProps: {
      "value": (_vm.squad.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          Provide a phone number where Color Of Change can reach you. This information will be not displayed publicly.\n        ")])]), _vm._v(" "), (_vm.squad.phone) ? _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.sms),
      expression: "squad.sms"
    }],
    attrs: {
      "id": "squad-sms",
      "disabled": !_vm.squad.phone,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.squad.sms) ? _vm._i(_vm.squad.sms, null) > -1 : (_vm.squad.sms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.squad.sms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.squad.sms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.squad.sms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.squad.sms = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "squad-sms"
    }
  }, [_vm._v("I would like to receive updates via SMS")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-website"
    }
  }, [_vm._v("\n          Website\n          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('website')),
      expression: "errors.has('website')"
    }],
    attrs: {
      "data-error": ""
    }
  }, [_vm._v(_vm._s(_vm.errors.first('website')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.website),
      expression: "squad.website"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        url: true,
        required: false
      }),
      expression: "{ url: true, required: false}"
    }],
    attrs: {
      "type": "text",
      "name": "website",
      "id": "squad-website"
    },
    domProps: {
      "value": (_vm.squad.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.website = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          Provide a website URL where future squad members can find your squad.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('label', {
    attrs: {
      "for": "squad-org"
    }
  }, [_vm._v("Organization Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.squad.organizationName),
      expression: "squad.organizationName"
    }],
    attrs: {
      "type": "text",
      "id": "squad-org"
    },
    domProps: {
      "value": (_vm.squad.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.squad.organizationName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "u-form-hint"
  }, [_vm._v("\n          If your squad is associated with an organization, provide the organization's name here.\n        ")])]), _vm._v(" "), _vm._m(0)])]) : _c('div', [_c('p', [_vm._v("Thank you for creating a squad. You will be notified when your request has been approved.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-mt2 u-mb2"
  }, [_c('button', {
    staticClass: "Button Button--outline",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n          Submit\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77fdd9dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/vue/components/squad-form.vue
// module id = 343
// module chunks = 0